import {
  NEE_USA_FILE_INDEX,
  SECOND_NEE_USA_FILE_INDEX,
  STATUS,
} from '../enums/common'
import { RadioButtonOptions } from '../components/step5/Options'
import { getOptionLabelByValue } from '../services/utils'
import { IStep5WithUploadProps } from '../interfaces/Step5'
import { getItemSuffix } from '../utils/getItemSuffix'

const Step5NationaliteAmericaineHook = (props: IStep5WithUploadProps) => {
  const { state, form, folderData, item } = props
  const { watch } = form
  const nationaliteAmericaineSuffix = `nationalite_americaine${getItemSuffix(
    item
  )}`
  const isNeeUsaSuffix = `is_nee_usa${getItemSuffix(item)}`
  const americanTaxInputSuffix = `is_nee_usa${getItemSuffix(item)}`

  const nationalite_americaine = folderData[nationaliteAmericaineSuffix]
  const is_nee_usa = folderData[isNeeUsaSuffix]
  const american_tax_input = folderData[americanTaxInputSuffix]
  const watchNationaliteAmericaine: string = watch(
    nationaliteAmericaineSuffix,
    nationalite_americaine
  )
  const watchAmericanTaxInput: string = watch(
    americanTaxInputSuffix,
    american_tax_input
  )
  const watchIsNeeUsa: string = watch(isNeeUsaSuffix, is_nee_usa)

  const nationaliteAmericaineFalse = watchNationaliteAmericaine === '1'
  const nationaliteAmericaineTrue = watchNationaliteAmericaine === '0'
  const americanTaxInputFalse =
    nationaliteAmericaineTrue && watchAmericanTaxInput === '1'
  const americanTaxInputTrue =
    nationaliteAmericaineTrue && watchAmericanTaxInput === '0'
  const isNeeUsaTrue = nationaliteAmericaineFalse && watchIsNeeUsa === '0'

  let showRadioNationaliteUsaLabel = true
  let showRadioNationaliteUsaLabelSecondForm = true
  let radioNationaliteUsaLabel = ''
  let showRadioNeeUsaLabel = true
  let showRadioNeeUsaLabelSecondForm = true
  let radioNeeUsaLabel = ''

  if (
    state &&
    (state[NEE_USA_FILE_INDEX] || state[SECOND_NEE_USA_FILE_INDEX])
  ) {
    const statusUsa = state[NEE_USA_FILE_INDEX]?.status
    const statusUsa2 = state[SECOND_NEE_USA_FILE_INDEX]?.status

    showRadioNationaliteUsaLabel = statusUsa !== STATUS.validated
    showRadioNationaliteUsaLabelSecondForm = statusUsa2 !== STATUS.validated
    showRadioNeeUsaLabel = statusUsa !== STATUS.validated
    showRadioNeeUsaLabelSecondForm = statusUsa2 !== STATUS.validated

    if (
      !showRadioNationaliteUsaLabel ||
      !showRadioNationaliteUsaLabelSecondForm
    ) {
      radioNationaliteUsaLabel = getOptionLabelByValue(
        RadioButtonOptions,
        watchNationaliteAmericaine
      )
    }

    if (!showRadioNeeUsaLabel || !showRadioNationaliteUsaLabelSecondForm) {
      radioNeeUsaLabel = getOptionLabelByValue(
        RadioButtonOptions,
        watchIsNeeUsa
      )
    }
  }

  return {
    americanTaxInputFalse,
    americanTaxInputTrue,
    nationaliteAmericaineFalse,
    nationaliteAmericaineTrue,
    isNeeUsaTrue,
    showRadioNationaliteUsaLabel,
    showRadioNationaliteUsaLabelSecondForm,
    radioNationaliteUsaLabel,
    showRadioNeeUsaLabel,
    showRadioNeeUsaLabelSecondForm,
    radioNeeUsaLabel,
  }
}

export default Step5NationaliteAmericaineHook
